/**
 * v-click-lock 指令
 * 点击后立即禁用按钮，等绑定的 async 函数返回后才重新启用。
 * 防止高危操作（提交/保存/删除）重复点击。
 *
 * 使用方式（替换 @click）：
 *   <el-button v-click-lock="handleSave">保存</el-button>
 *   <el-button v-click-lock="() => handleDelete(row)">删除</el-button>
 *
 * 注意：绑定的函数应返回 Promise，指令会 await 它。
 *       已使用 $confirm 二次确认的按钮无需加此指令（$confirm 自身已起到阻隔作用）。
 */
export default {
  bind(el, binding, vnode) {
    let locked = false;

    const handler = async function (event) {
      if (locked) return;
      const fn = binding.value;
      if (typeof fn !== "function") return;

      locked = true;
      setDisabled(true);

      // 标记为提交模式 → GlobalLoading 显示浮动指示器
      const store = vnode.context && vnode.context.$store;
      if (store) store.commit("loading/SET_SUBMIT_MODE", true);

      try {
        const result = fn(event);
        // 支持 async/await 和 .then() 两种模式
        if (result && typeof result.then === "function") {
          await result;
        }
      } catch (e) {
        console.error("[v-click-lock] handler error:", e);
      } finally {
        if (store) store.commit("loading/SET_SUBMIT_MODE", false);
        setDisabled(false);
        locked = false;
      }
    };

    el._clickLockHandler = handler;
    el.addEventListener("click", handler);

    function setDisabled(disabled) {
      // Element UI 的 el-button — 通过组件实例设置
      if (vnode.componentInstance && vnode.componentInstance.disabled !== undefined) {
        vnode.componentInstance.disabled = disabled;
        return;
      }
      // 原生的 button / 其他元素
      if (el.tagName === "BUTTON" || el.tagName === "INPUT") {
        el.disabled = disabled;
      }
    }
  },
  unbind(el) {
    if (el._clickLockHandler) {
      el.removeEventListener("click", el._clickLockHandler);
      delete el._clickLockHandler;
    }
  },
};



// WEBPACK FOOTER //
// ./src/directives/clickLock.js